
import { useEffect } from 'react';
import { FileUpload } from '@/components/dashboard/FileUpload';
import { ProductTable } from '@/components/dashboard/ProductTable';
import { SearchFilters } from '@/components/dashboard/SearchFilters';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { fetchDashboardData } from '@/store/sagas/dashboardSaga';

export default function Dashboard() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Product Dashboard</h1>
        <FileUpload />
      </div>

      <div className="flex items-center justify-between gap-4">
        <SearchFilters />
      </div>

      <ProductTable 
        selectedCompetitors={[]}
        onCompetitorRemove={() => {}}
      />
    </div>
  );
}
